export default "__VITE_ASSET__C2XSBz8s__"